import { createSlice } from "@reduxjs/toolkit";
import appointmentDetails from "@custom/rtk-apis/appointment/appointmentDetails";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const appointmentDetailSlice = createSlice({
  name: "appointmentDetailSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(appointmentDetails.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(appointmentDetails.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(appointmentDetails.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default appointmentDetailSlice.reducer;
